
import { RevButtonRounded } from '@ds/components/ButtonRounded'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import isEmpty from 'lodash/isEmpty'

import {
  DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  FIRST_PAGINATION_INDEX,
} from './Pagination.constants'
import translations from './Pagination.translations'
import PaginationButton from './PaginationButton.vue'
import { pagination } from './utils'

export default {
  components: {
    RevButtonRounded,
    PaginationButton,
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    nbPages: {
      type: Number,
      required: true,
    },
    withLinks: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations: () => translations,

    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    icons() {
      return {
        left: IconChevronLeft,
        right: IconChevronRight,
      }
    },

    previousLink() {
      return this.withLinks && this.hasDotsFirstPage
        ? this.getPageLink(this.currentPage - 1)
        : undefined
    },

    nextLink() {
      return this.withLinks && this.hasDotsLastPage
        ? this.getPageLink(this.currentPage + 1)
        : undefined
    },

    pagination() {
      return pagination(this.currentPage, this.nbPages)
    },
    paginationLinks() {
      return this.withLinks
        ? this.pagination.map((pageNumber) => this.getPageLink(pageNumber))
        : []
    },
    hasPagination() {
      return !isEmpty(this.pagination)
    },
    firstPage() {
      const [firstPaginationItem] = this.pagination

      return firstPaginationItem === FIRST_PAGINATION_INDEX
        ? null
        : FIRST_PAGINATION_INDEX
    },
    firstPageLink() {
      return this.withLinks
        ? this.getPageLink(FIRST_PAGINATION_INDEX)
        : undefined
    },
    lastPage() {
      const [lastPaginationItem] = this.pagination.slice(-1)

      return lastPaginationItem === this.nbPages ? null : this.nbPages
    },
    lastPageLink() {
      return this.withLinks ? this.getPageLink(this.nbPages) : undefined
    },
    hasDotsLastPage() {
      const [lastPaginationItem] = this.pagination.slice(-1)

      return lastPaginationItem + 1 < this.nbPages
    },
    hasDotsFirstPage() {
      const [firstPaginationItem] = this.pagination

      return firstPaginationItem - 1 > FIRST_PAGINATION_INDEX
    },
  },
  methods: {
    onClick(pageNumber) {
      this.$emit('change', 'page', pageNumber)
    },

    getPageLink(pageNumber) {
      const { page, ...query } = this.$route.query ?? {}

      // Let's not have the ?page=x parameter for the first page to avoid having both "?page=1"
      // and the one without to be indexed by search engines.
      // Putting it to undefined would work on the URL generation part but will break algolia search
      const newQuery = pageNumber === 1 ? query : { ...query, page: pageNumber }

      return {
        name: this.$route.name,
        params: this.$route.params,
        hash: this.$route.hash,
        query: newQuery,
        type: 'internal',
      }
    },
  },
}
